// SEUL module autorisé à importer preferences.ts. Le code métier obtient l'API de
// stockage exclusivement via declareStorageDomain → déclarer son cycle de vie est
// le prix d'entrée. (`lng` i18next : écrit par la lib, hors périmètre — survit au logout.)
import {
    getString,
    setString,
    getJSON,
    setJSON,
    remove,
    getKeys
} from '../preferences/preferences';

export interface StorageApi {
    getString: (key: string) => Promise<string | null>;
    setString: (key: string, value: string) => Promise<void>;
    getJSON: <T>(key: string) => Promise<T | null>;
    setJSON: <T>(key: string, value: T) => Promise<void>;
    remove: (key: string) => Promise<void>;
    getKeys: () => Promise<string[]>;
}

export interface StorageDomainConfig {
    name: string;
    /** Action à la déconnexion. Implémentation vide = décision explicite de conserver. */
    onLogout: (storage: StorageApi) => Promise<void>;
    /** Action au changement d'identité (entrée/sortie du mode accompagné). Vide = conserver. */
    onIdentitySwitch: (storage: StorageApi) => Promise<void>;
}

const storageApi: StorageApi = Object.freeze({
    getString,
    setString,
    getJSON,
    setJSON,
    remove,
    getKeys
});

const declaredDomains: StorageDomainConfig[] = [];

/** La porte : déclarer un domaine (nom + onLogout) est le SEUL moyen d'obtenir l'API. */
export function declareStorageDomain(config: StorageDomainConfig): StorageApi {
    declaredDomains.push(config);
    return storageApi;
}

type StorageLifecycleEvent = 'onLogout' | 'onIdentitySwitch';

/** Chaque domaine applique sa décision, sans bloquer les autres. */
async function runStorageLifecycle(event: StorageLifecycleEvent): Promise<void> {
    for (const domain of declaredDomains) {
        try {
            await domain[event](storageApi);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`[storage] ${domain.name} ${event} failed`, error);
        }
    }
}

/** Déconnexion. */
export const runStorageLogout = (): Promise<void> => runStorageLifecycle('onLogout');

/** Bascule d'identité (entrée/sortie du mode accompagné act-as). */
export const runStorageSwitch = (): Promise<void> => runStorageLifecycle('onIdentitySwitch');
